import { Box, Container, Link, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { FaInstagram, FaFacebook, FaTelegram, FaGithub } from 'react-icons/fa';
  
function Footer() {
    return (
    <Box id='Footer' bg={useColorModeValue('white.50')} >
        <Container
            as={Stack}
            maxW={'6xl'}
            py={8}
            spacing={4}
            justify={'center'}
        >
            <Text fontSize="xl" fontWeight='bold' align={'center'}>WLD Watches</Text>
            <Text px={15} fontWeight='bold'>| ABOUT US |</Text>
            <Text fontSize="sm" textAlign='justify' px={15}>
                    Welcome to our website WLD Watches! Where you can find the finest watches and strap watches where we provide for you from all across the globe.
                    Our store is one of the most prestigious and glorious watch stores with containing the most affortable watches and watch straps. If you have
                    any enquiries please contact us and check out our social media below!
            </Text>
        </Container>

        <Box
            borderTopWidth={1}
            borderStyle={'solid'}
            borderColor={useColorModeValue('w.900', 'gray.700')}
        >
            <Container
                as={Stack}
                maxW={'6xl'}
                py={8}
                direction={{ base: 'column', md: 'row' }}
                spacing={4}
                justify={{ base: 'center', md: 'space-between' }}
                align={{ base: 'center', md: 'center' }}
            >
                <Text>&copy; {new Date().getFullYear()} TEAM 4 WLD Watches. All rights reserved</Text>
                <Stack direction={'row'} spacing={8}>
                    <Link href="https://t.me/Eu_jin" target="_blank"><FaTelegram size={24} /></Link>
                    <Link href="https://www.instagram.com/___jin___/" target="_blank"><FaInstagram size={24} /></Link>
                    <Link href="https://www.facebook.com/jinheng.eu/" target="_blank"><FaFacebook size={24} /></Link>
                    <Link href="https://github.com/Jinheng02" target="_blank"><FaGithub size={24} /></Link>
                </Stack>
            </Container>
        </Box>
    </Box>
    );
}

  export default Footer;